import {Component, OnInit} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {AppState} from '../../../state/appState';
import {Observable} from 'rxjs';
import {PaginatedResponseModel} from '../../../shared/models/paginated.response.model';
import {WebchargeListModel} from '../../../shared/services/webcharge/webchargeList.model';
import {GetWebcharges} from '../../../state/actions/appState.webcharges.actions';
import {OpenModalWebchargeDetail} from '../../../state/actions/appState.modals.actions';
import {WebchargeStatus} from '../../../shared/services/webcharge/webchargeStatus.enum';
import {take, tap} from 'rxjs/operators';
import {Debounce} from 'lodash-decorators';

@Component({
  selector: 'app-webcharge',
  templateUrl: './webcharge.component.html',
  styleUrls: ['./webcharge.component.scss']
})
export class WebchargeComponent implements OnInit {
  @Select(AppState.webcharges$) webcharges$: Observable<PaginatedResponseModel<WebchargeListModel>>;
  webchargeStatusEnum = Object.values(WebchargeStatus);
  webchargeStatus: WebchargeStatus = null;

  private referenceFilter = '';
  private paycardIdFilter = '';

  constructor(private store: Store) { }

  ngOnInit(): void {
    this.store.dispatch(new GetWebcharges());
  }

  onOpenDetails(reference: string) {
    this.store.dispatch(new OpenModalWebchargeDetail(reference));
  }

  onPageSelected(page: number) {
    this.webcharges$.pipe(
      take(1),
      tap(paycards => {
        this.getWebcharges(page, paycards.size, this.referenceFilter, this.paycardIdFilter, this.webchargeStatus);
      })
    ).subscribe();
  }

  onSizeSelected(size: number) {
    this.webcharges$.pipe(
      take(1),
      tap(paycards => {
        this.getWebcharges(paycards.number, size, this.referenceFilter, this.paycardIdFilter, this.webchargeStatus);
      })
    ).subscribe();
  }

  @Debounce(1000)
  onReferenceFilterChange(reference: string) {
    this.referenceFilter = reference;
    this.webcharges$.pipe(
      take(1),
      tap(paycards => {
        this.getWebcharges(paycards.number, paycards.size, this.referenceFilter, this.paycardIdFilter, this.webchargeStatus);
      })
    ).subscribe();
  }

  @Debounce(1000)
  onPaycardIdFilterChange(paycardId: string) {
    this.paycardIdFilter = paycardId;
    this.webcharges$.pipe(
      take(1),
      tap(paycards => {
        this.getWebcharges(paycards.number, paycards.size, this.referenceFilter, this.paycardIdFilter, this.webchargeStatus);
      })
    ).subscribe();
  }

  onPreorderStatusChange(status: WebchargeStatus) {
    this.webchargeStatus = status;
    this.webcharges$.pipe(
      take(1),
      tap(paycards => {
        this.getWebcharges(paycards.number, paycards.size, this.referenceFilter, this.paycardIdFilter, this.webchargeStatus);
      })
    ).subscribe();
  }

  private getWebcharges(page: number, size: number, reference: string, paycardId: string, status: WebchargeStatus) {
    this.store.dispatch(new GetWebcharges(page, size, reference, paycardId, status));
  }
}
